/**
 * ProfileReportFilters.jsx
 */

import React from 'react';

const ProfileReportFilters = ({
  roles = [],
  selectedRoles,
  onChangeRoles,
  onGenerate,
  onClear,
  onListAll,
}) => {
  return (
    <div className="mb-5">
      <div className="mb-2 d-flex flex-column col-12 col-sm-4 col-md-3">
        <label className="mb-3" htmlFor="roles">
          Perfis
        </label>
        <select
          id="roles"
          className="br-input"
          multiple
          value={selectedRoles}
          onChange={(e) =>
            onChangeRoles([...e.target.selectedOptions].map((o) => o.value))
          }
        >
          <option value="all">Todos</option>
          {roles.map((role) => (
            <option key={role.id} value={role.id}>
              {role.title}
            </option>
          ))}
        </select>
      </div>

      <div className="actions mt-3">
        <button
          type="button"
          className="br-button secondary mr-2"
          onClick={onClear}
        >
          Limpar
        </button>

        <button
          type="button"
          className="br-button primary mr-2"
          onClick={onGenerate}
        >
          Gerar relatório
        </button>

        <button type="button" className="br-button" onClick={onListAll}>
          Listar todos
        </button>
      </div>
    </div>
  );
};

export default ProfileReportFilters;
